import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Enterprise } from '@app/core/interfaces/enterprise';
import { SiteLocal } from '@app/core/interfaces/site-local';
import { EnterpriseContextService } from '@app/shared/services/context/enterprise-context.service';
import { toMap } from '@app/utils/common';
import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { FormMappingAttribute } from '@app/utils/form-mapping/decorators/form-mapping-attribute';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';
import { loggerFor } from '@app/utils/logger';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { FormGroupTyped } from 'src/types/typed-forms';

@UntilDestroy()
@FormMapping()
class FormModel extends FormMappingModel {
  @FormMappingAttribute('siteId')
  siteId: number;
}

@UntilDestroy()
@Component({
  selector: 'portal-vpbx-switcher',
  templateUrl: './vpbx-switcher.component.html',
  standalone: false,
})
export class VpbxSwitcherComponent implements OnInit {
  sitesLocal$!: Observable<SiteLocal[]>;

  @Input()
  set disabled(value: boolean) {
    if (value === true) {
      this.form.controls.siteId.disable();
    } else {
      this.form.controls.siteId.enable();
    }
  }

  @Output()
  onChange: EventEmitter<SiteLocal> = new EventEmitter<SiteLocal>();

  sites: { [key: string]: SiteLocal };
  logger = loggerFor('VpbxSwitcherComponent');

  public form: FormGroupTyped<FormModel> = FormModel.formGroup();

  constructor(private enterpriseContextService: EnterpriseContextService) {}

  ngOnInit() {
    this.sitesLocal$ = this.enterpriseContextService.enterprise.data$.pipe(
      map((enterprise) => enterprise.localSites),
      untilDestroyed(this)
    );

    combineLatest([this.sitesLocal$, this.enterpriseContextService.enterprise.data$])
      .pipe(
        untilDestroyed(this),
        filter(([, enterprise]) => enterprise.local !== undefined),
        distinctUntilChanged(
          ([, enterprise1], [, enterprise2]) =>
            enterprise1.local.defaultSite === enterprise2.local.defaultSite
        )
      )
      .subscribe(([sites, enterprise]: [SiteLocal[], Enterprise]) => {
        this.logger.info('Got new values', sites, enterprise);
        const defaultSiteId = enterprise.local.defaultSite;
        const defaultSite = sites.find((siteLocal) => siteLocal.id === defaultSiteId) || sites[0];

        this.form.patchValue(
          FormModel.from({
            siteId: defaultSite.id,
          })
        );

        this.onChange.emit(defaultSite);
        this.sites = toMap(sites, 'id');
      });
  }

  onValueChange() {
    this.onChange.emit(this.sites[this.form.value.siteId]);
  }
}
